import { IRefundService, RefundRequest, RefundResponse } from '../@posturinn/client-react';
import {
	FETCH_REFUND_STATUS_FAILED,
	FETCH_REFUND_STATUS_FULFILLED,
	FETCH_REFUND_STATUS_PENDING,
} from '../constants/actions/refundsActions';

//actions for refunds

export const fetchRefundPending = () => ({
	type: FETCH_REFUND_STATUS_PENDING,
	payload: null,
});

export const fetchRefundFulfilled = refund => ({
	type: FETCH_REFUND_STATUS_FULFILLED,
	payload: {
		refund,
	},
});

export const fetchRefundFailed = error => ({
	type: FETCH_REFUND_STATUS_FAILED,
	payload: {
		error,
	},
});

export const fetchRefunds = () => {
	return async (dispatch, getState) => {
		try {
			const { injector } = getState().mobizReducer;
			const refundService: IRefundService = injector.get(IRefundService);
			dispatch(fetchRefundPending());
			refundService.getRefund().subscribe({
				next: (refund: RefundRequest) => {
					dispatch({ type: FETCH_REFUND_STATUS_FULFILLED, payload: refund });
				},
				error: err => {
					dispatch({ type: FETCH_REFUND_STATUS_FAILED, payload: null });
					console.log(err);
				},
			});
		} catch (error) {
			dispatch(fetchRefundFailed(error));
		}
	};
};

export const sendBankInfo = bankInfo => {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			try {
				const { injector } = getState().mobizReducer;
				const refundService: IRefundService = injector.get(IRefundService);
				dispatch(fetchRefundPending());
				refundService.sendBankInfo(bankInfo).subscribe({
					next: (refund: RefundResponse) => {
						dispatch({ type: FETCH_REFUND_STATUS_FULFILLED, payload: refund });
						resolve(refund); // Resolve the Promise with the refund
					},
					error: err => {
						dispatch({ type: FETCH_REFUND_STATUS_FAILED, payload: err });
						console.log(err);
						reject(err); // Reject the Promise with the error
					},
				});
			} catch (error) {
				dispatch(fetchRefundFailed(error));
				reject(error); // Reject the Promise with the error
			}
		});
	};
};

/* const response :{ data: IRefunds } = {
				data: {
					identificationNumber: "2104932049",
					name: "Benni",
					email: "Benni",
					phone: "Benni",
					totalAmount: "7000",
					hasReceivedPayment: false,
					hasSubmittedBankInfo: false,
					amountCorrected: "7000",
					amountInCorrection: "7000",
					amountUncorrected: "7000",
					currency: "SEK",
				}
			} */
